import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { DateTimePicker } from "../ui/date-and-time-picker";
import { BidFormValues } from "../admin/bids/types";
import { format } from "date-fns";
import { FullDatesNotice, SelectedDateFullWarning } from "./FullDatesNotice";
import { FullDateDto } from "@/types/fullDate";

/**
 * `fullDates` is passed in rather than fetched here, so the admin bid form that
 * shares this component makes no request for it and shows no notice.
 */
export const EventDetailsFields = ({
  form,
  fullDates = [],
}: {
  form: UseFormReturn<BidFormValues>;
  fullDates?: FullDateDto[];
}) => {
  return (
    <>
      <FullDatesNotice fullDates={fullDates} />

      <FormField
        control={form.control}
        name="startTime"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Party Start Time</FormLabel>
            <FormControl>
              <div className="space-y-2">
                <div className="w-[280px] justify-start text-left font-normal">
                  <DateTimePicker
                    granularity="minute"
                    jsDate={field.value}
                    onJsDateChange={field.onChange}
                  />
                </div>
                {field.value && (
                  <div className="text-sm text-muted-foreground">
                    Selected: {format(field.value, "EEEE, M/d/yyyy h:mm a")}
                  </div>
                )}
                <SelectedDateFullWarning
                  fullDates={fullDates}
                  selectedDate={field.value}
                />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="eventLength"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Party Length (hours)</FormLabel>
            <FormControl>
              <Input
                type="number"
                min="1"
                step="any"
                placeholder="2.5"
                {...field}
                onChange={(e) => field.onChange(Number(e.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="attendees"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Number of Attendees</FormLabel>
            <FormControl>
              <Input
                type="number"
                min="1"
                placeholder="100"
                {...field}
                onChange={(e) => field.onChange(Number(e.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
